import { SelectOption } from '@/components/form-builder/form-builder.types';
import { WithMetadata } from '@/types';
import { DownloadSnippetDto, Meeting, MeetingDto, ParticipantDto, PlannedDossier, UploadSnippetDto } from '@/types/meeting.types';
import { createStore, withProps } from '@ngneat/elf';

export interface MeetingStateProps {
  response: Partial<WithMetadata<Meeting>>;
  dto: Partial<MeetingDto>;
  serverState: any;
  comSelected: SelectOption;
  inviteeSelected: ParticipantDto;
  acSelected: SelectOption;
  plannedDossiers: PlannedDossier[];
  acs: any[];
  isEqual: boolean;
  uploadSnippetDto: Partial<UploadSnippetDto>;
  downloadSnippetDto: Partial<DownloadSnippetDto>;
}

export const meetingInitialState: MeetingStateProps = {
  response: {},
  dto: {},
  serverState: undefined,
  comSelected: { name: '', code: '' },
  acSelected: { name: '', code: undefined },
  inviteeSelected: {
    nom: '',
    prenom: '',
    mail: '',
    fonction: '',
    organisme: '',
    present: false,
    userId: '',
  },
  plannedDossiers: [],
  acs: [],
  isEqual: false,
  uploadSnippetDto: {},
  downloadSnippetDto: {},
};

export const meetingStateStore = createStore({ name: 'meeting-state' }, withProps<MeetingStateProps>({ ...meetingInitialState }));
